@if (yearsError()) {
  <app-error-page
    [error]="yearsError()"
    (clickBack)="router.navigate(['/organizations'])"
    class="block"
    style="height: calc(100vh - 5rem - 10rem)"
  />
} @else if (parseRequestsLoadError()) {
  <app-error-page
    [error]="parseRequestsLoadError()"
    (clickBack)="router.navigate(['/organizations'])"
    class="block"
    style="height: calc(100vh - 5rem - 10rem)"
  />
} @else {
  <app-organization-sidebar-layout>
    <app-page-header>
      <app-page-title>
        {{ 'cockpit.supplierContracts.page.title' | transloco }}
      </app-page-title>
      <div slot="end" class="flex flex-col sm:flex-row gap-3">
        @if (parseRequestsLoading()) {
          <ui-skeleton class="w-60 h-10 rounded-md" />
        } @else if (activeParseRequests().length > 0) {
          <app-parse-requests-active-dropdown
            [activeParseRequests]="activeParseRequests()"
            (clickParseRequest)="onClickGoToParseRequestDetails($event)"
          />
        }
        <app-supplier-contract-contact-button [organizationId]="organizationId()">
          <ui-button mode="outlined">
            <ng-icon name="heroDocumentMagnifyingGlass" size="20" slot="start" class="!block" />
            {{ 'cockpit.supplierContracts.contactButton.label' | transloco }}
          </ui-button>
        </app-supplier-contract-contact-button>
        <app-create-parse-request-button
          [organizationId]="organizationId()"
          [disabled]="!allowContractAdd()"
        />
      </div>
    </app-page-header>

    @if (createError()) {
      <section class="mb-5">
        <ui-alert color="error">
          <ng-icon slot="icon" name="heroXCircle" size="20" class="!block" />
          <h3 slot="title">
            {{ 'cockpit.supplierContracts.page.createErrorAlert.title' | transloco }}
          </h3>
          <p>
            {{ 'cockpit.supplierContracts.page.createErrorAlert.message' | transloco }}
          </p>

          <ui-button
            slot="action"
            [iconOnly]="true"
            mode="ghost"
            size="small"
            class="hidden md:inline"
            (click)="onClickCloseCreateErrorAlert()"
          >
            <ng-icon name="heroXMark" size="20" class="!block" />
          </ui-button>
          <ui-button
            slot="action"
            mode="ghost"
            size="small"
            class="md:hidden"
            (click)="onClickCloseCreateErrorAlert()"
          >
            <ng-icon name="heroXMark" size="20" slot="start" class="!block" />
            {{ 'cockpit.supplierContracts.page.createErrorAlert.hideButton' | transloco }}
          </ui-button>
        </ui-alert>
      </section>
    }
    @if (parseRequestCreatedId(); as id) {
      <section class="mb-5">
        <app-parse-request-created-alert
          (clickGoToDetails)="onClickGoToParseRequestDetails(id)"
          (clickHide)="dismissParseRequestCreatedAlert()"
        />
      </section>
    }
    <app-supplier-contracts-filter-form slot="sticky-header" (changeFilter)="onChangeFilter()" />
    <section class="@container flex flex-col gap-5">
      @if (showFutureYearsAlert()) {
        <ui-alert>
          <ng-icon slot="icon" name="heroInformationCircle" size="20" class="!block" />
          <h3 slot="title">
            {{ 'cockpit.supplierContracts.page.futureYearsAlert.title' | transloco }}
          </h3>
          <p>
            {{ 'cockpit.supplierContracts.page.futureYearsAlert.message' | transloco }}
          </p>
          <ui-button
            class="inline-block mt-4"
            mode="outlined"
            size="small"
            (click)="onClickGoToFutureYearContracts()"
          >
            {{ 'cockpit.supplierContracts.page.futureYearsAlert.button' | transloco }}
          </ui-button>
        </ui-alert>
      } @else if (showPreviousYearsAlert()) {
        <ui-alert>
          <ng-icon slot="icon" name="heroInformationCircle" size="20" class="!block" />
          <h3 slot="title">
            {{ 'cockpit.supplierContracts.page.previousYearsAlert.title' | transloco }}
          </h3>
          <p>
            {{ 'cockpit.supplierContracts.page.previousYearsAlert.message' | transloco }}
          </p>
          <ui-button
            class="inline-block mt-4"
            mode="outlined"
            size="small"
            (click)="onClickGoToPreviousYearContracts()"
          >
            {{ 'cockpit.supplierContracts.page.previousYearsAlert.button' | transloco }}
          </ui-button>
        </ui-alert>
      }

      @if (view() === 'grid') {
        <app-supplier-contracts-grid
          [supplierContracts]="supplierContracts()"
          [fullPrice]="fullPrice()"
          [currentYear]="year()"
          [showLoadMorePlaceholders]="showLoadMorePlaceholders()"
          [limit]="limit()"
          appInfiniteScroll
          (nearEnd)="onLoadMore()"
        >
          <li class="min-h-100 block">
            <div
              class="w-full h-full p-6 flex items-center justify-center rounded-lg border border-dashed border-outline dark:border-outline-darkmode"
            >
              <app-create-parse-request-button
                [organizationId]="organizationId()"
                mode="outlined"
                [disabled]="!allowContractAdd()"
              />
            </div>
          </li>
        </app-supplier-contracts-grid>
      } @else {
        <div class="w-full overflow-x-auto">
          <app-supplier-contracts-table
            [supplierContracts]="supplierContracts()"
            [orderBy]="orderBy()"
            [orderDirection]="orderDirection()"
            (changeOrder)="onChangeOrder($event)"
            [fullPrice]="fullPrice()"
            [currentYear]="year()"
            [organizationId]="organizationId()"
            [showLoadMorePlaceholders]="showLoadMorePlaceholders()"
            [limit]="limit()"
            appInfiniteScroll
            (nearEnd)="onLoadMore()"
          />
        </div>
      }
    </section>
  </app-organization-sidebar-layout>
}

<app-tutorial-supplier-contracts-popover />
